import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils3.js';
import { d as defineCustomElement$4 } from './custom-popper2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const IdentityAddressForm = /*@__PURE__*/ proxyCustomElement(class IdentityAddressForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.address = {};
        this.inputHandler = (name, value) => {
            this.address[name] = value;
            this.address = Object.assign({}, this.address);
        };
    }
    handleAddressChange(newValues) {
        this.handleFormUpdate(newValues);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (h(Host, { key: 'ee0ad865c40fb26b4138c0b68a944f05f96fdc65' }, h("div", { key: '15e35c582daaa30f5d7523d30445546fa9d648b8', class: "row gy-3" }, h("div", { key: '066f08f377cdb74ff640787fdc54082b74952de0', class: "col-12 col-md-8" }, h("form-control-text", { key: '9b96dd42003108200b0ebb0bb5f246e48028967a', name: "line1", label: "Street Address", defaultValue: (_a = this.defaultValues) === null || _a === void 0 ? void 0 : _a.line1, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line1, inputHandler: this.inputHandler, helpText: "\u200B\u200BEnter your address exactly as stated on your driver's license. No PO Boxes." })), h("div", { key: 'c0f25515428343bdbb6e2ee715dc8e7996ae922b', class: "col-12 col-md-4" }, h("form-control-text", { key: 'af541412c694f912fb2d511d1b72d02274e4ef21', name: "line2", label: "Apartment, Suite, etc. (optional)", defaultValue: (_c = this.defaultValues) === null || _c === void 0 ? void 0 : _c.line2, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.line2, inputHandler: this.inputHandler })), h("div", { key: '61cdbddac8ab71b22feab3a5169f5fda57f751ee', class: "col-12" }, h("form-control-text", { key: '1861b0a9807c2f0679eaba07f313d4dfaf563fd2', name: "city", label: "City", defaultValue: (_e = this.defaultValues) === null || _e === void 0 ? void 0 : _e.city, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.city, inputHandler: this.inputHandler })), h("div", { key: 'cb3aab077c4e3824e6becf46396b67114ff24f16', class: "col-12 col-md-6" }, h("form-control-select", { key: '0adfc316afc87f6aa91198d01da7ad3a86b6221d', name: "state", label: "State", defaultValue: (_g = this.defaultValues) === null || _g === void 0 ? void 0 : _g.state, options: StateOptions, errorText: (_h = this.errors) === null || _h === void 0 ? void 0 : _h.state, inputHandler: this.inputHandler })), h("div", { key: '36ae7e269ba4f31541ffc2d20e0931500b33732a', class: "col-12 col-md-6" }, h("form-control-text", { key: '7f8a76e23c78f505133a3fcd23575ae0e04e2c7a', name: "postal_code", label: "Postal Code", defaultValue: (_j = this.defaultValues) === null || _j === void 0 ? void 0 : _j.postal_code, errorText: (_k = this.errors) === null || _k === void 0 ? void 0 : _k.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler, inputHandler: this.inputHandler })), h("div", { key: '67d3c31c5450fffcc5d333f2a6927f805d88fc4f', class: "col-12" }, h("form-control-select", { key: 'c99faee491f35231c852e9a6096e5822c389d6cb', name: "country", label: "Country", options: [{ label: 'United States', value: 'USA' }], inputHandler: this.inputHandler, defaultValue: (_l = this.defaultValues) === null || _l === void 0 ? void 0 : _l.country, errorText: (_m = this.errors) === null || _m === void 0 ? void 0 : _m.country,
            // just for now so we skip handling country specificities
            disabled: true })))));
    }
    static get watchers() { return {
        "address": ["handleAddressChange"]
    }; }
}, [0, "justifi-identity-address-form", {
        "handleFormUpdate": [16, "handle-form-update"],
        "errors": [8],
        "defaultValues": [8, "default-values"],
        "address": [32]
    }, undefined, {
        "address": ["handleAddressChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-identity-address-form", "custom-popper", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, IdentityAddressForm);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { IdentityAddressForm as I, defineCustomElement as d };
